var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.928589,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#00FF1A",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_2604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 7.25C11.7265 7.25 8.25 10.7265 8.25 15C8.25 19.2735 11.7265 22.75 16 22.75C20.2735 22.75 23.75 19.2735 23.75 15C23.75 10.7265 20.2735 7.25 16 7.25ZM16 21.25C12.5535 21.25 9.75 18.4465 9.75 15C9.75 11.5535 12.5535 8.75 16 8.75C19.4465 8.75 22.25 11.5535 22.25 15C22.25 18.4465 19.4465 21.25 16 21.25Z",
    fill: "#31C242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.55C15.8011 12.55 15.6103 12.629 15.4697 12.7696C15.329 12.9103 15.25 13.1011 15.25 13.3V18.837C15.25 19.0359 15.329 19.2266 15.4697 19.3673C15.6103 19.5079 15.8011 19.587 16 19.587C16.1989 19.587 16.3897 19.5079 16.5303 19.3673C16.671 19.2266 16.75 19.0359 16.75 18.837V13.3C16.75 13.1011 16.671 12.9103 16.5303 12.7696C16.3897 12.629 16.1989 12.55 16 12.55ZM16 10.413C15.8011 10.413 15.6103 10.492 15.4697 10.6326C15.329 10.7733 15.25 10.9641 15.25 11.163V11.1655C15.25 11.5795 15.5855 11.9145 16 11.9145C16.1958 11.9094 16.3818 11.8281 16.5185 11.6879C16.6551 11.5476 16.7316 11.3595 16.7316 11.1637C16.7316 10.9679 16.6551 10.7798 16.5185 10.6396C16.3818 10.4993 16.1958 10.418 16 10.413Z",
    fill: "#31C242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_2604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoo);
export default __webpack_public_path__ + "static/media/infoo.c67b99206653932f1db7b8875892412e.svg";
export { ForwardRef as ReactComponent };